import { Quote, Star } from 'lucide-react';
import { TESTIMONIALS } from '../constants/restaurant';

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="bg-brand-cream py-24 md:py-32 px-6 md:px-12 lg:px-16"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-xs uppercase tracking-[0.3em] font-semibold text-brand-burgundy mb-5">
            Guest Reviews
          </p>
          <h2
            data-testid="testimonials-heading"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-brand-coffee tracking-tight"
          >
            Loved by our{' '}
            <span className="italic text-brand-burgundy">Sunshine Coast</span> family.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative bg-brand-surface border border-brand-ivory rounded-3xl p-8 md:p-10 shadow-[0_10px_40px_rgba(43,27,23,0.04)] hover:shadow-[0_30px_60px_rgba(139,26,26,0.08)] hover:-translate-y-1 transition-all duration-500"
              style={{ backgroundColor: '#FFFFFF' }}
            >
              <Quote className="w-10 h-10 text-brand-gold/60 mb-5" />
              <div className="flex gap-1 mb-5" aria-label={`${t.rating} star rating`}>
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-brand-gold text-brand-gold" />
                ))}
              </div>
              <p className="font-serif text-xl md:text-2xl text-brand-coffee leading-[1.55]">
                “{t.quote}”
              </p>
              <p className="mt-6 text-sm uppercase tracking-[0.2em] font-semibold text-brand-mocha">
                — {t.name}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
